import FormInput from './FormInput'

export default FormInput

export * from './FormInput'
